export default __webpack_public_path__ + "static/media/guardianbg.e4ae1bb7.jpg";